import {DraggableId} from '../../../../../lib/components/drag-n-drop';
import {GapFillingModel, GapItem} from '../models';

export interface ItemPosition {
  readonly paragraph: number;
  readonly index: number;
}

export interface DndGapState {
  // id of slot
  readonly filledWith: string | null;
  readonly checked: boolean;
  readonly checkCount: number;
}

export interface DndGapStates {
  readonly [index: string]: DndGapState
}

export interface DndGapFillingState {
  // shuffled positions of gap item ids
  readonly itemOrder: readonly string[];
  readonly states: DndGapStates;
}

/******************************************************************************/

export interface KbtGapState {
  // value of entered text
  readonly filledWith: string;
  // how many times this gap was checked
  readonly checkCount: number;
  // currently is this gap checked
  readonly checked: boolean;
}

export interface KbtGapStates {
  readonly [index: string]: KbtGapState;
}

export interface KbtGapFillingState {
  readonly states: KbtGapStates;
}

/******************************************************************************/

export type GapFillingState = KbtGapFillingState | DndGapFillingState;

/******************************************************************************/

export function positionToItemId(position: ItemPosition) {
  return position.paragraph.toString(10) + '/' + position.index.toString(10);
}

export function positionFromItemId(draggableId: DraggableId): ItemPosition {
  let split = draggableId.split('/');
  return {
    paragraph: parseInt(split[0], 10),
    index: parseInt(split[1], 10)
  };
}

/******************************************************************************/

export function gapItemsById(model: GapFillingModel): { readonly [index: string]: GapItem } {
  const result: { [index: string]: GapItem } = {};

  for (let paragraphIndex = 0; paragraphIndex < model.paragraphs.length; paragraphIndex++) {
    const paragraph = model.paragraphs[paragraphIndex];
    for (let index = 0; index < paragraph.items.length; index++) {
      let item = paragraph.items[index];
      if (item.type !== 'gap')
        continue;
      const position: ItemPosition = {paragraph: paragraphIndex, index: index};
      const itemId = positionToItemId(position);
      result[itemId] = item;
    }
  }

  return result;
}
